import { upperFirst } from 'lodash-es';
import { UnitType } from '../../graphql/types';

export class UnitUtils {
  static getName(unit?: UnitType | null) {
    return (unit && unit.name && upperFirst(unit.name)) || '';
  }
}
